import { render, staticRenderFns } from "./InsectCountTable.vue?vue&type=template&id=0f3213b7&scoped=true&"
import script from "./InsectCountTable.vue?vue&type=script&lang=js&"
export * from "./InsectCountTable.vue?vue&type=script&lang=js&"
import style0 from "./InsectCountTable.vue?vue&type=style&index=0&id=0f3213b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3213b7",
  null
  
)

/* custom blocks */
import block0 from "./InsectCountTable.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3213b7')) {
      api.createRecord('0f3213b7', component.options)
    } else {
      api.reload('0f3213b7', component.options)
    }
    module.hot.accept("./InsectCountTable.vue?vue&type=template&id=0f3213b7&scoped=true&", function () {
      api.rerender('0f3213b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InsectCountTable.vue"
export default component.exports